/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//アコーディオン
$('.agrias-accordion-item__desc-wrapper').hide();
$(function(){
  $('.agrias-accordion-item').on('click', function () {
    $(this).children('.agrias-accordion-item__desc-wrapper').slideToggle(300);
    $(this).children('.agrias-accordion-item__term-wrapper').toggleClass('--open', 300);
  });
});


// 商品ページ追従する高さ指定
$(window).on('load resize', function(){
  let windowSize = $(window).width();
  if (windowSize >= 1007) {;
    getStickyHeight();
    $('.js-accordion-trigger').on('click', function() {
      getStickyHeight();
    })
  } else {
    $('.agrias-product-sticky').css('height', 'auto');
  }
});
function getStickyHeight() {
  let heightArray = [];
  let stickyHeight = 0;
  setTimeout(function(){
    $('.agrias-product-section--narrow').each(function(index) {
      let elementHeight = $(this).outerHeight();
      heightArray.push(elementHeight);
    });
    console.log("heightArray:" + heightArray);
    for (let i = 0; i < heightArray.length; i++) {
      stickyHeight += heightArray[i];
    }
    console.log("stickyHeight:" + stickyHeight);
    $('.agrias-product-sticky').css('height', stickyHeight - 130);
  }, 500);
};


//商品ページ追従ブロック
$(function(){
  let price = $('.Price').html();
  price = price.split('<span>');
  price = price.slice(0, -1);
  price = String(price);
  price = price.replace(',', '');
  price = price.slice(0, -1);
  price = Number(price);

  let price_compareAt = $('.Price--compareAt').html();
  if (price_compareAt ) {
    price_compareAt = price_compareAt.split('<span>');
    price_compareAt = price_compareAt.slice(0, -1);
    price_compareAt = String(price_compareAt);
    price_compareAt = price_compareAt.replace(',', '');
    price_compareAt = price_compareAt.slice(0, -1);
    price_compareAt = Number(price_compareAt);
  }

  let arySpinnerCtrl = [];
  let spin_speed = 20; //変動スピード
  let num;

  //長押し押下時
  $('.agrias-product-quantity__button').on('touchstart mousedown click', function(e){
      if(arySpinnerCtrl['interval']) return false;
      let target = $(this).data('target');
      arySpinnerCtrl['target'] = target;
      arySpinnerCtrl['timestamp'] = e.timeStamp;
      arySpinnerCtrl['cal'] = Number($(this).data('cal'));
      //クリックは単一の処理に留める
      if(e.type == 'click'){
          spinnerCal();
        arySpinnerCtrl = [];

        return false;
      }
      //長押し時の処理
      setTimeout(function(){
          //インターバル未実行中 + 長押しのイベントタイプスタンプ一致時に計算処理
          if(!arySpinnerCtrl['interval'] && arySpinnerCtrl['timestamp'] == e.timeStamp){
              arySpinnerCtrl['interval'] = setInterval(spinnerCal, spin_speed);
          }
      }, 500);
  });

  //長押し解除時 画面スクロールも解除に含む
  $(document).on('touchend mouseup scroll', function(e){
      if(arySpinnerCtrl['interval']){
          clearInterval(arySpinnerCtrl['interval']);
          arySpinnerCtrl = [];
      }
  });

  // 直接数字書き換え時の処理
  $(document).on('change input', '.counter', function() {
    num = $('.counter').val();
    console.log(num);
    quantitySelector();
  });

  //変動計算関数
  function spinnerCal() {
    let target = $(arySpinnerCtrl['target']);
    num = Number(target.val());
    num = num + arySpinnerCtrl['cal'];

    if (Number(target.data('min')) > num) {
      target.val(Number(target.data('min')));
      num = Number(target.data('min'));
    } else {
      target.val(num);
    }
    quantitySelector();
  }

  //数量変更で小計と今すぐ購入ボタンhref変更
  function quantitySelector() {

    // 今すぐ購入ボタンhref変更
    let href = $('a.agrias-product__dynamic-checkout').attr('href');
    let variant = href.split(':')[0];
    let url = variant + ':' + num;
    $("a.agrias-product__dynamic-checkout").attr("href", url);

    // 小計変更

  console.log("price");
  console.log(price);
  console.log(num);

    let subtotal = price * num;
    subtotal = String(subtotal).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    subtotal = subtotal + '円<span> (税込)</span>';
    console.log(subtotal);
    if (price_compareAt) {
      $('.agrias-product-sticky .Price--highlight').html(subtotal);
      let subtotal_compareAt = price_compareAt * num;
      subtotal_compareAt = String(subtotal_compareAt).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      subtotal_compareAt = subtotal_compareAt + '円<span> (税込)</span>';
      console.log(subtotal_compareAt);
      $('.agrias-product-sticky .Price--compareAt').html(subtotal_compareAt);
    } else {
      $('.agrias-product-sticky .Price').html(subtotal);
    }
  }
});


// 要素をスライドしながら非表示にする関数
const slideUp = (el, duration = 300) => {
  el.style.height = el.offsetHeight + "px";
  el.offsetHeight;
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + "ms";
  el.style.transitionTimingFunction = "ease";
  el.style.overflow = "hidden";
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  setTimeout(() => {
    el.style.display = "none";
    el.style.removeProperty("height");
    el.style.removeProperty("padding-top");
    el.style.removeProperty("padding-bottom");
    el.style.removeProperty("margin-top");
    el.style.removeProperty("margin-bottom");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
    el.style.removeProperty("transition-timing-function");
    el.classList.remove("is-open");
  }, duration);
};

// 要素をスライドしながら表示する関数
const slideDown = (el, duration = 300) => {
  el.classList.add("is-open");
  el.style.removeProperty("display");
  let display = window.getComputedStyle(el).display;
  if (display === "none") {
    display = "block";
  }
  el.style.display = display;
  let height = el.offsetHeight;
  el.style.overflow = "hidden";
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  el.offsetHeight;
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + "ms";
  el.style.transitionTimingFunction = "ease";
  el.style.height = height + "px";
  el.style.removeProperty("padding-top");
  el.style.removeProperty("padding-bottom");
  el.style.removeProperty("margin-top");
  el.style.removeProperty("margin-bottom");
  setTimeout(() => {
    el.style.removeProperty("height");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
    el.style.removeProperty("transition-timing-function");
  }, duration);
};

// 要素をスライドしながら交互に表示/非表示にする関数
const slideToggle = (el, duration = 300) => {
  if (window.getComputedStyle(el).display === "none") {
    return slideDown(el, duration);
  } else {
    return slideUp(el, duration);
  }
};

// アコーディオンを全て取得
const accordions = document.querySelectorAll(".js-accordion");
// 取得したアコーディオンをArrayに変換(IE対策)
const accordionsArr = Array.prototype.slice.call(accordions);

accordionsArr.forEach((accordion) => {
  // Triggerを全て取得
  const accordionTriggers = accordion.querySelectorAll(".accordion__title");
  // TriggerをArrayに変換(IE対策)
  const accordionTriggersArr = Array.prototype.slice.call(accordionTriggers);

  accordionTriggersArr.forEach((trigger) => {
    // Triggerにクリックイベントを付与
    trigger.addEventListener("click", () => {
      // '.is-active'クラスを付与or削除
      trigger.parentNode.classList.toggle("is-active");
      // 開閉させる要素を取得
      const content = trigger.parentNode.querySelector(".accordion__content");
      // 要素を展開or閉じる
      slideToggle(content);
    });
  });
});

   $(".detail-btn").on('click',function(){
  var fire = $(this).prev().attr("href")
     console.log(fire)
     window.location.href = fire;
      });

//動画のモーダル
$(".video-open").modaal({
  type: 'video',
  overlay_close:true,//モーダル背景クリック時に閉じるか
  background: '#28BFE7', // 背景色
  overlay_opacity:0.8, // 透過具合
  before_open:function(){// モーダルが開く前に行う動作
    $('html').css('overflow-y','hidden');/*縦スクロールバーを出さない*/
  },
  after_close:function(){// モーダルが閉じた後に行う動作
    $('html').css('overflow-y','scroll');/*縦スクロールバーを出す*/
  }
});

$(".info").modaal({
  overlay_close:true,//モーダル背景クリック時に閉じるか
  before_open:function(){// モーダルが開く前に行う動作
    $('html').css('overflow-y','hidden');/*縦スクロールバーを出さない*/
  },
  after_close:function(){// モーダルが閉じた後に行う動作
    $('html').css('overflow-y','scroll');/*縦スクロールバーを出す*/
  }
});

// $(function(){
//  $("#video")[0].play()
// });
   
(() => {
    'use strict';

    const target = document.body; 
    const observer = new MutationObserver(function (mutations) {
      if($("#video1").parent().parent().hasClass("is-selected")){
    if($(this)[0].paused){
          $(this)[0].play();
        } }
     else{
        $(this)[0].pause();
      }

       if($("#video2").parent().parent().hasClass("is-selected")){
    if($(this)[0].paused){
          $(this)[0].play();
        } }
     else{
        $(this)[0].pause();
      }
    });

    // 監視を開始
    observer.observe(target, {
        attributes: true, // 属性変化の監視
        attributeOldValue: true, // 変化前の属性値を matation.oldValue に格納する
        characterData: true, // テキストノードの変化を監視
        characterDataOldValue: true, // 変化前のテキストを matation.oldValue に格納する
        childList: true, // 子ノードの変化を監視
        subtree: true // 子孫ノードも監視対象に含める
    });
})();

$(function () {
    $('.play-btn').on('click', function(){ // 再生ボタンが押されたら
        if($(this).hasClass('playActive')){
            $(this).parent().find(".video1").get(0).pause();
        }else{
            $(this).parent().find(".video1").get(0).play();
        }
    });

    $('.video1').on('playing', function(){
        $(this).next().addClass('playActive'); 
        $(this).attr('controls', ''); // ブラウザが表示する再生ボタンを非表示にするために後から属性付与
    });

    $(".video1").on('pause', function(){
        $(this).next().removeClass('playActive');
        $(this).removeAttr('controls');
    });

    // $('.video1').on('ended', function(){ 
    //     $('.playBt').removeClass('playActive');
    //     $(this).removeAttr('controls');
    // });
});